function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as n } from "react/jsx-runtime";
import * as m from "react";
import C from "./badge.js";
import w from "./generated/mistica-icons/icon-user-account-regular.js";
import { useIsInverseVariant as E } from "./theme-variant-context.js";
import { avatar as L, image as P } from "./avatar.css-mistica.js";
import { vars as a } from "./skins/skin-contract.css-mistica.js";
import { getPrefixedDataAttributes as S } from "./utils/dom.js";
const k = (r, o)=>{
    if (!o) return 0;
    const t = r / 2, e = o === !0 ? 5 : 10;
    return t * (1 - Math.sin(Math.PI / 4)) - e;
}, y = (r, o)=>{
    if (!o) return null;
    let t;
    return r <= 40 ? t = 14 : r <= 64 ? t = 16 : t = 18, /* @__PURE__ */ n("span", {
        style: {
            fontSize: t,
            textTransform: "uppercase"
        },
        children: o
    });
}, R = (_param)=>{
    var { size: r , src: o , Icon: t = w , badge: e , initials: c = "" , "aria-label": u , dataAttributes: f  } = _param, s = _object_without_properties(_param, [
        "size",
        "src",
        "Icon",
        "badge",
        "initials",
        "aria-label",
        "dataAttributes"
    ]);
    var _s_backgroundColor, _s_textColor;
    const l = E(), g = (_s_backgroundColor = s.backgroundColor) !== null && _s_backgroundColor !== void 0 ? _s_backgroundColor : l ? a.colors.brandHigh : a.colors.brandLow, b = (_s_textColor = s.textColor) !== null && _s_textColor !== void 0 ? _s_textColor : l ? a.colors.textPrimaryInverse : a.colors.brand, [h, i] = m.useState(!1);
    m.useEffect(()=>{
        i(!1);
    }, [
        o
    ]);
    const v = s.border ? `1px solid ${a.colors.borderLow}` : "none", p = c.trim().slice(0, 2), d = k(r, e), x = e === !0 ? void 0 : e || 0, I = !!o && !h, A = r <= 40 ? 16 : 24;
    return /* @__PURE__ */ n(C, {
        value: x,
        top: d,
        right: d,
        children: /* @__PURE__ */ n("div", _object_spread_props(_object_spread({
            className: L,
            role: "img",
            "aria-label": u !== null && u !== void 0 ? u : c,
            style: {
                width: r,
                height: r,
                color: b,
                background: g,
                boxSizing: "border-box",
                border: v
            }
        }, S(f, "Avatar")), {
            children: I ? /* @__PURE__ */ n("img", {
                src: o,
                className: P,
                onError: ()=>i(!0),
                role: "none",
                width: r,
                height: r
            }) : y(r, p) || /* @__PURE__ */ n(t, {
                size: A,
                color: "currentColor"
            })
        }))
    });
}, j = R;
export { j as default };
